import { FileService, MessageService } from '@philips-emr/tws-core/lib/services';
import { HttpMethod } from '@philips-emr/tws-core/lib/services/http-service';

import { Endpoint } from '../constants';

import { ToastServiceStipulator } from './toast-service';

enum IeAnexo {
  DOSSIE_BENEFICIARIO_DOCUMENTO = 'dossie-beneficiario-documento',
  DOSSIE_CONTRATO_DOCUMENTO = 'dossie-contrato-documento',
  FOLHA_PAGAMENTO = 'folha-pagamento',
  GUIA = 'guia',
  INCLUSAO_ANEXOS = 'inclusao-anexos',
  MENSAGEM_ANEXO = 'mensagem-anexo',
  MIGRACAO_BENEFIACIARIO = 'migracao-benefiaciario',
  MODELO_LOTE = 'modelo-lote',
  REINCLUSAO_BENEF_ANEXO = 'reinclusao-benef-anexo',
  REQUISICAO = 'requisicao',
  REQUISICAO_AUDITORIA = 'requisicao-auditoria',
  REQUISICAO_ANEXO = 'requisicao-anexo',
  SEG_SOLIC_ALT_ANEXO = 'seg-solic-alt-anexo',
  SEGURADO_DOC_ARQ = 'segurado-doc-arq',
  SOLICITACAO_RESC_ANEXO = 'solicitacao-resc-anexo',
}

class StipulatorFileService {

  public static download(ieAnexo: IeAnexo, nrSeqAnexo: number, name?: string): void {
    FileService.download(Endpoint.GET.DOWNLOAD, name, { ieAnexo, nrSeqAnexo }, HttpMethod.GET)
      .catch(() => ToastServiceStipulator.error(MessageService.translate('stipulator.arquivo-nao-localizado')));
  }

}

export {
  StipulatorFileService,
  IeAnexo,
};
